export default class FiscalShiftStatus {
    static get Open () { return '1' }
    static get Closed () { return '2' }
}
